import React, {useState} from 'react'


const Product3 = (props) => {

    const [product, SetProduct] = useState(props.produkt);

    function ShowProduct({product, index}) {
    return (
           
            <li class="card">
              <img src={product.img} className="card-img-top" alt={product.prodnamn} />
              <div class="card-body">
                  {product.pris ? <> <p className="card__price">{product.pris}</p> <span className="card__ordPrice">{product.ordpris}</span> </>: <span className="card__ordPrice-ord">{product.ordpris}</span> }
                <h3 class="card__title">{product.prodnamn}</h3>
                <p className="card__brodtext">{product.text}</p>
                <a href={product.recUrl} className="card__link">Läs recension</a>
                <a href={product.buttonUrl} class="btn btn-warning" target="_blank" rel="noopener noreferrer">Köp nu</a>
              </div>
            </li>  
    )
}

    return (
            <ul class="card-show">
                {product.map((product, index) => (
                <ShowProduct key={index} product={product} /> 
                ))}
            </ul>
    )
}

export default Product3
